import React from "react";
import AnimateLines from "@/components/AnimateLine";
import EthImage from "@/components/EthImage";
import AdaptiveImage from "@/components/AdaptiveImage";
import ImageItem from "@/components/ImageItem";

import { useTranslation } from "react-i18next";
import { AnimateProps } from "../../../types";
import { fomatDecimal } from "@/utils";

import "./index.css";

const Part6: React.FC<AnimateProps> = (props) => {
  const { t } = useTranslation();
  const { data } = props
  const now = new Date(data.most_expensive.buy_timestamp * 1000)

  const m = now.getMonth();
  const d = now.getDate();
  const h = now.getHours() > 9 ? now.getHours() : `0${now.getHours()}` ;
  const s = now.getMinutes()> 9 ? now.getMinutes() : `0${now.getMinutes()}`;

  return (
    <div className="part_contain part_contain_6">
      <div style={{ flex: 1, width: "100%" }} />
      <div className="part_content">
        <AnimateLines animateType={props.type}>
          <p className="text_title mb_16">
            Your Treasure
          </p>
          <div className="row_center mb_30">
            <ImageItem url={data.most_expensive.image_url} />
            <p className="text_remind_num">{data.most_expensive.name || data.most_expensive.collection_name || ' #' + data.most_expensive.token_id}</p>
          </div>
          <p className="mb_4">
            <span className="text_content">Cost</span>&ensp;
            <span className="text_num">{fomatDecimal(data.most_expensive.buy_cost)}</span>
            <EthImage />
          </p>
          <p className="text_num mb_20">
            <span>{t(`month.${m}`)} {d}{t('day')} {h}:{s}</span>
          </p>
          <p className="text_content">This must mean something</p>
          <p className="text_content">important to you!</p>
        </AnimateLines>
      </div>
      <div style={{ flex: 1, width: "100%" }} />
      <AnimateLines animateType={props.type} animateName="animate__fadeIn">
        <div className="ml_auto">
          <AdaptiveImage name="Frame101027" />
        </div>
      </AnimateLines>
      <div style={{ flex: 2, width: "100%" }} />
    </div>
  );
};

export default Part6;
